import Spinner from './Spinner.jsx';

const variants = {
  primary:   'bg-accent hover:brightness-110 text-white',
  secondary: 'bg-bg-elevated hover:bg-border border border-border-strong hover:border-accent/40',
  danger:    'bg-red-500 hover:bg-red-600 text-white',
  ghost:     'bg-transparent hover:bg-bg-elevated border border-transparent hover:border-border',
};

export default function Button({ children, variant = 'primary', loading = false, disabled = false, type = 'button', className = '', ...rest }) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl text-sm font-medium
                  transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed
                  ${variants[variant]} ${className}`}
      style={variant === 'secondary' || variant === 'ghost' ? { color: 'var(--text-secondary)' } : {}}
      {...rest}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </button>
  );
}
